// extracted by mini-css-extract-plugin
export default {"innerWrapper":"vt-z","tooltipWrapper":"wt-z","icon":"xt-z","tooltip":"yt-z","content":"zt-z"};